import { Container } from './styles'
import { CouponService } from '../../../services'
import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@taglivros/tag-components'
import { useCategory, useOrderSummary, usePayment } from '../../../contexts'

export function PlanButton( { categorySelected, color, handlePlanClick, mobile, planId, titlePlan } ) {
  const { setCoupon, coupon } = useOrderSummary()
  const { findCategoryById, findPlanById } = useCategory()
  const { paymentMethod } = usePayment()

  async function handleClick() {
    if ( coupon.code ) {
      try {
        const response = await CouponService.get( {
          'code': coupon.code,
          'isRecommendation': coupon.isRecommendation,
          planId,
          paymentMethod,
        } )

        const category = findCategoryById( categorySelected )
        const plan = findPlanById( category, planId )

        setCoupon( { ...coupon, ...response }, plan )
      } catch ( error ) {
        setCoupon( {
          'benefits': [],
          'code': ''
        } )
      }
    }

    handlePlanClick( planId )
  }

  return (
    <Container
      categorySelected={ categorySelected }
      color={ color }
      mobile={ mobile }
      onClick={ handleClick }
    >
      <Typography
        as="span"
        color="white"
        fontSizeDesktop="xxxs"
        fontSizeMobile="xxxs"
        fontWeight="xl"
        variant="customText"
      >
        { titlePlan }
      </Typography>
    </Container>
  )
}

PlanButton.propTypes = {
  'categorySelected': PropTypes.number.isRequired,
  'color': PropTypes.string.isRequired,
  'handlePlanClick': PropTypes.func.isRequired,
  'mobile': PropTypes.bool,
  'planId': PropTypes.number.isRequired,
  'titlePlan': PropTypes.string.isRequired,
}

PlanButton.defaultProps = {
  'mobile': false,
}
